import { dataTrendDesktop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendDesktop = /*#__PURE__*/createIcon(dataTrendDesktop)
export default IconTrendDesktop
